var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[(_vm.type == 'live-video')?_c('Session'):(_vm.type == 'iframe')?_c('VideoLoop',{attrs:{"hd":true,"iframe":_vm.roomData.iframe}}):(_vm.type == 'map')?_c('ExpoMap',{attrs:{"expoId":_vm.expoId}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }